import BaseCollection from "lib/collection";
import Order from "models/order";
import SchemaModel from "models/schema";
import { getStore } from "store";

const schemaCache = {};

const Orders = BaseCollection.extend({
    initialize: function (models, options) {
        options = Object.assign({ pageSize: 100 }, options);
        this.__select_all = false;
        this.pageSize = options.pageSize;
    },

    model: function (attrs, options) {
        const Model = options.collection.getSchemaModel(attrs.__schema_id);

        return new Model(attrs, options);
    },

    getSchemaModel: function (schemaId) {
        const { schemas } = getStore().getState().entities;
        if (schemas) {
            if (schemaCache[schemaId]) {
                return schemaCache[schemaId];
            } else {
                const schemaRecord = schemas[schemaId].toJS();
                const schema = new SchemaModel(schemaRecord);
                const schemaModel = schema.getModel();
                schemaCache[schemaId] = schemaModel;
                return schemaModel;
            }
        } else {
            return Order;
        }
    },

    isModel: function (model) {
        return model instanceof this.getSchemaModel(model.__schema_id);
    },

    url: function () {
        return "/api/v3.0/orders";
    },

    toIdArray: function () {
        return this.map((order) => {
            return order._id;
        });
    },
});

export default Orders;
